var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  evalExpr: () => evalExpr,
  isExprObject: () => isExprObject,
  processMaybeExpr: () => processMaybeExpr,
  tryEvalExpr: () => tryEvalExpr
});
module.exports = __toCommonJS(stdin_exports);
var import_cloneDeep = __toESM(require("lodash/cloneDeep"));
function isExprObject(o) {
  return typeof o === "object" && o && "$expr" in o && Object.keys(o).length === 1 && typeof o.$expr === "string";
}
function processMaybeExpr(data, ...ctxs) {
  if (data === void 0)
    return void 0;
  if (isExprObject(data)) {
    return evalExpr(data.$expr, ...ctxs);
  }
  return (0, import_cloneDeep.default)(data);
}
function evalExpr(expr, ...ctx) {
  const ctx2 = ctx.filter((x) => typeof x === "object" && x !== null);
  const ctxNames = ctx2.map((_, i) => `__$ctx${i}`);
  let fn;
  try {
    fn = new Function(...ctxNames, `${ctxNames.map((name) => `with(${name})`).join(" ")} return (
${expr}
)`);
  } catch (_a) {
    fn = new Function(...ctxNames, `${ctxNames.map((name) => `with(${name})`).join(" ")} {
${expr}
}`);
  }
  return fn(...ctx2);
}
function tryEvalExpr(expr, defaultValue, ...ctx) {
  try {
    return evalExpr(expr, ...ctx);
  } catch (err) {
    return defaultValue;
  }
}
